import React from "react";
import Layout from "../../../components/layout";
import ApmNavbar from "../../../components/navbar-apm";
import CtaButton from "../../../components/signupCtaButton";
import CtaBar from "../../../components/ctabar";

const IndexPage = () => (
  <Layout title="APM" hasSubNav={true}>
    <ApmNavbar selection="overview" />
    <section className="section infra-hero-section hero">
      <div className="hero-body">
        <div className="container">
          <div className="columns is-vcentered">
            <div className="column">
              <div className="htitle">Slice ’n Dice Across Microservices</div>
              <div className="htitle-callout">Next-Gen Java APM</div>
              <CtaButton style={{ marginTop: "2.8rem" }} />
            </div>
            <div className="column">
              <img src="/img/apm/one-line-apm.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="section testimonial-section">
      <div className="container">
        <div className="columns is-vcentered">
          <div className="column has-text-right is-two-fifths">
            <img src="/img/users/kupivip.png" alt="" style={{ width: "19.5rem" }} />
          </div>
          <div className="column">
            <div className="quote">We tried other products... but DripStat was the best</div>
          </div>
        </div>
      </div>
    </section>

    <section className="section infra-features-section">
      <div className="container">
        <div className="columns infra-feature is-variable is-8">
          <div className="column is-two-fifths">
            <div className="feature-title">See Across your Microservices</div>
            <div className="feature-desc">
              Get the total picture. Traditional APMs only allow seeing data one application at a time. DripStat goes beyond that, allowing you to slice n dice data across all your apps in real time,
              giving you unseen levels of visibility
            </div>
          </div>
          <div className="column">
            <img src="/img/apm/microservices.png" alt="" style={{ height: "15.3125rem", transform: "translate(3.75rem, 1.875rem)" }} />
          </div>
        </div>

        <div className="columns infra-feature is-variable is-8">
          <div className="column">
            <img src="/img/apm/security-2.png" alt="" style={{ height: "14.25rem", transform: "translateX(10.5rem)" }} />
          </div>

          <div className="column is-two-fifths">
            <div className="feature-title">Security and Privacy</div>
            <div className="feature-desc">
              DripStat is used by some of the world’s largest companies across sectors like health, finance, journalism, which have extreme requirements around security and privacy of their data. Feel
              free to contact us if you have any concerns.
            </div>
          </div>
        </div>

        <div className="columns infra-feature is-variable is-8">
          <div className="column is-two-fifths">
            <div className="feature-title">Extreme Detail</div>
            <div className="feature-desc">
              DripStat offers an unprecendented level of detail in your running code, unlike any you have seen in any other APM solutions. We even have the widest range of supported Databases and
              Frameworks out of the box.
            </div>
          </div>
          <div className="column">
            <img src="/img/apm/details-4.png" alt="" style={{ height: "20.56rem", transform: "translateX(6.0625rem)" }} />
          </div>
        </div>

        <div className="columns infra-feature is-variable is-8">
          <div className="column">
            <img src="/img/apm/aws-2.png" alt="" style={{ height: "8.5625rem", transform: "translateX(3.9375rem)" }} />
          </div>

          <div className="column is-two-fifths">
            <div className="feature-title">AWS metrics from the Application level</div>
            <div className="feature-desc">
              DripStat goes beyond AWS Cloudwatch metrics and shows you the calls to AWS services from the application level, giving you a much more accurate picture of how your applications are
              interacting with AWS services.
            </div>
          </div>
        </div>
      </div>
    </section>

    <CtaBar trial={true} />
  </Layout>
);

export default IndexPage;
